export interface ExpirationInterface {
  unit: TIME_UNITS;
  value: number | null;
}

export enum TIME_UNITS {
  DAYS = 'days',
  HOURS = 'hours',
  MINUTES = 'minutes',
  SECONDS = 'seconds',
}
